import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChecklistSummaryRoutingModule } from './checklist-summary-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ChecklistSummaryRoutingModule
  ]
})
export class ChecklistSummaryModule { }
